var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836473"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "white",
    stroke: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 19C13.9 19 13 19.9 13 21C13 22.1 13.9 23 15 23C16.1 23 17 22.1 17 21C17 19.9 16.1 19 15 19ZM29 19C27.9 19 27 19.9 27 21C27 22.1 27.9 23 29 23C30.1 23 31 22.1 31 21C31 19.9 30.1 19 29 19ZM22 19C20.9 19 20 19.9 20 21C20 22.1 20.9 23 22 23C23.1 23 24 22.1 24 21C24 19.9 23.1 19 22 19Z",
    fill: "#63658E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsCircled);
export default __webpack_public_path__ + "static/media/threeDotsCircled.3475baa5c1c08aa05e8507482daa0106.svg";
export { ForwardRef as ReactComponent };